// import React, { useEffect, useState } from 'react';
// import api from '../api/api';

// export default function CampaignStats() {
//   const [stats, setStats] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     api.get('/campaign/stats')
//       .then(r => {
//         console.log('Campaign stats response:', r.data);
//         setStats(r.data);
//       })
//       .catch(err => {
//         console.error('Failed to fetch campaign stats, falling back to 0:', err);
//         setStats({ 
//           winners: 0, 
//           freeWins: 0, 
//           discount50Wins: 0,
//           discount30Wins: 0,
//           discount25Wins: 0,
//           discount20Wins: 0,
//           discount15Wins: 0,
//           discount5Wins: 0,
//           buy1Get1Wins: 0,
//           bumperWins: 0,
//           startDate: null,
//           endDate: null
//         });
//       })
//       .finally(() => setLoading(false));
//   }, []);

//   const fmt = (n) => Number(n || 0).toLocaleString();

//   const dateRange = () => {
//     if (!stats?.startDate || !stats?.endDate) return '';
//     const s = new Date(stats.startDate);
//     const e = new Date(stats.endDate);
//     const months = ['January','February','March','April','May','June',
//                     'July','August','September','October','November','December'];
    
//     if (isNaN(s.getTime()) || isNaN(e.getTime())) return '';
    
//     const sm = months[s.getMonth()], em = months[e.getMonth()];
//     const sy = s.getFullYear(),      ey = e.getFullYear();
    
//     if (sm === em && sy === ey)
//       return `${s.getDate()}–${e.getDate()} ${em} ${ey}`;
//     return `${s.getDate()} ${sm} – ${e.getDate()} ${em} ${ey}`;
//   };

//   return (
//     <div style={{
//       minHeight     : '100vh',
//       background    : 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
//       display       : 'flex',
//       flexDirection : 'column',
//       alignItems    : 'center',
//       justifyContent: 'flex-start',
//       padding       : '0 0 30px 0',
//       fontFamily    : 'Arial, sans-serif',
//       boxSizing     : 'border-box',
//     }}>

//       {/* ── Custom CSS Animations for Gentle Winner Blinking/Glow ── */}
//       <style>{`
//         @keyframes slowGlow {
//           0%, 100% {
//             box-shadow: 0 4px 12px rgba(34, 197, 94, 0.12);
//             border-color: #bbf7d0;
//             transform: scale(1);
//           }
//           50% {
//             box-shadow: 0 8px 22px rgba(34, 197, 94, 0.3);
//             border-color: #86efac;
//             transform: scale(1.015);
//           }
//         }

//         @keyframes slowBlink {
//           0%, 100% {
//             opacity: 1;
//           }
//           50% {
//             opacity: 0.55;
//           }
//         }

//         .winner-card-pulse {
//           animation: slowGlow 3s ease-in-out infinite;
//         }

//         .winner-count-blink {
//           animation: slowBlink 2.5s ease-in-out infinite;
//         }
//       `}</style>

//       {/* ── Top Nav Bar ── */}
//       <div style={{
//         width        : '100%',
//         background   : '#fff',
//         borderBottom : '1px solid #e2e8f0',
//         padding      : '16px 28px',
//         display      : 'flex',
//         alignItems   : 'center',
//         gap          : '12px',
//         boxSizing    : 'border-box',
//         boxShadow    : '0 2px 4px rgba(0,0,0,0.02)'
//       }}>
//         <div style={{
//           width         : '40px',
//           height        : '40px',
//           borderRadius  : '10px',
//           background    : 'linear-gradient(135deg, #1A2060, #3B4FC7)',
//           display       : 'flex',
//           alignItems    : 'center',
//           justifyContent: 'center',
//           boxShadow     : '0 4px 10px rgba(59,79,199,0.3)'
//         }}>
//           <span style={{ color:'#fff', fontWeight:900, fontSize:'18px' }}>L</span>
//         </div>
//         <span style={{ fontWeight:800, fontSize:'20px', color:'#1A2060', letterSpacing:'0.8px' }}>
//           LOGO
//         </span>
//       </div>

//       {/* ── Main Card Container ── */}
//       <div style={{
//         width        : '100%',
//         maxWidth     : '520px',
//         margin       : '24px auto 0',
//         padding      : '0 20px',
//         boxSizing    : 'border-box',
//       }}>

//         {/* Lock / Trophy Icon Header */}
//         <div style={{ textAlign:'center', marginBottom:'14px' }}>
//           <div style={{
//             display        : 'inline-flex',
//             alignItems     : 'center',
//             justifyContent : 'center',
//             width          : '72px',
//             height         : '72px',
//             background     : '#fff',
//             borderRadius   : '20px',
//             boxShadow      : '0 8px 20px rgba(0,0,0,0.06)',
//             border         : '1px solid #f1f5f9'
//           }}>
//             <svg width="34" height="34" viewBox="0 0 24 24" fill="none">
//               <rect x="3" y="11" width="18" height="11" rx="2" fill="#F59E0B"/>
//               <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="#92400E" strokeWidth="2.5" strokeLinecap="round"/>
//               <circle cx="12" cy="16" r="1.8" fill="#92400E"/>
//             </svg>
//           </div>
//         </div>

//         {/* Heading */}
//         <h1 style={{
//           textAlign    : 'center',
//           fontSize     : '24px',
//           fontWeight   : 900,
//           color        : '#0f172a',
//           margin       : '0 0 8px',
//           letterSpacing: '-0.5px'
//         }}>
//           Campaign Has Ended
//         </h1>

//         {/* Sub-text */}
//         <p style={{
//           textAlign    : 'center',
//           color        : '#64748b',
//           fontSize     : '14px',
//           lineHeight   : 1.5,
//           margin       : '0 0 22px',
//           padding      : '0 10px',
//         }}>
//           {loading
//             ? 'Loading campaign statistics...'
//             : `The LOGO Spin & Win campaign ran ${dateRange() ? `from ${dateRange()}` : ''}. Thank you to everyone who participated and won amazing prizes!`
//           }
//         </p>

//         {/* Stats Card Container */}
//         <div style={{
//           background   : '#fff',
//           border       : '1px solid #e2e8f0',
//           borderRadius : '20px',
//           padding      : '20px 20px',
//           marginBottom : '22px',
//           boxShadow    : '0 10px 30px rgba(0,0,0,0.04)',
//           boxSizing    : 'border-box',
//         }}>
//           <div style={{
//             textAlign    : 'center',
//             fontSize     : '11px',
//             fontWeight   : 800,
//             color        : '#94a3b8',
//             letterSpacing: '2px',
//             textTransform: 'uppercase',
//             marginBottom : '14px',
//           }}>
//             Official Campaign Results
//           </div>

//           {/* Total Winners Box */}
//           <div 
//             className="winner-card-pulse"
//             style={{
//               background  : 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
//               borderRadius: '14px',
//               padding     : '16px 16px',
//               textAlign   : 'center',
//               border      : '1.5px solid #bbf7d0',
//               marginBottom: '14px',
//               transition  : 'all 0.3s ease',
//             }}
//           >
//             <div 
//               className="winner-count-blink"
//               style={{ fontSize:'34px', fontWeight:900, color:'#16a34a', lineHeight:1 }}
//             >
//               {loading ? '...' : fmt(stats?.winners)}
//             </div>
//             <div style={{ fontSize:'13px', color:'#15803d', marginTop:'5px', fontWeight:800, letterSpacing:'0.3px' }}>
//               🏆 Total Winners
//             </div>
//           </div>

//           {/* Breakdown Grid (Ordered: FREE -> BUY 1 GET 1 -> 50% -> 30% -> 25% -> 20% -> 15% -> 5% -> Bumper) */}
//           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
            
//             {/* 1. Free Items */}
//             <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '12px 6px', textAlign: 'center', border: '1px solid #e2e8f0' }}>
//               <div style={{ fontSize:'16px', fontWeight:800, color:'#3b82f6' }}>{loading ? '...' : fmt(stats?.freeWins)}</div>
//               <div style={{ fontSize:'11px', color:'#64748b', marginTop:'4px', fontWeight:700 }}>FREE</div>
//             </div>

//             {/* 2. Buy 1 Get 1 */}
//             <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '12px 6px', textAlign: 'center', border: '1px solid #e2e8f0' }}>
//               <div style={{ fontSize:'16px', fontWeight:800, color:'#6366f1' }}>{loading ? '...' : fmt(stats?.buy1Get1Wins)}</div>
//               <div style={{ fontSize:'11px', color:'#64748b', marginTop:'4px', fontWeight:700 }}>BUY 1 GET 1</div>
//             </div>

//             {/* 3. 50% Off */}
//             <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '12px 6px', textAlign: 'center', border: '1px solid #e2e8f0' }}>
//               <div style={{ fontSize:'16px', fontWeight:800, color:'#ec4899' }}>{loading ? '...' : fmt(stats?.discount50Wins)}</div>
//               <div style={{ fontSize:'11px', color:'#64748b', marginTop:'4px', fontWeight:700 }}>50% OFF</div>
//             </div>

//             {/* 4. 30% Off */}
//             <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '12px 6px', textAlign: 'center', border: '1px solid #e2e8f0' }}>
//               <div style={{ fontSize:'16px', fontWeight:800, color:'#10b981' }}>{loading ? '...' : fmt(stats?.discount30Wins)}</div>
//               <div style={{ fontSize:'11px', color:'#64748b', marginTop:'4px', fontWeight:700 }}>30% OFF</div>
//             </div>

//             {/* 5. 25% Off */}
//             <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '12px 6px', textAlign: 'center', border: '1px solid #e2e8f0' }}>
//               <div style={{ fontSize:'16px', fontWeight:800, color:'#06b6d4' }}>{loading ? '...' : fmt(stats?.discount25Wins)}</div>
//               <div style={{ fontSize:'11px', color:'#64748b', marginTop:'4px', fontWeight:700 }}>25% OFF</div>
//             </div>

//             {/* 6. 20% Off */}
//             <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '12px 6px', textAlign: 'center', border: '1px solid #e2e8f0' }}>
//               <div style={{ fontSize:'16px', fontWeight:800, color:'#ef4444' }}>{loading ? '...' : fmt(stats?.discount20Wins)}</div>
//               <div style={{ fontSize:'11px', color:'#64748b', marginTop:'4px', fontWeight:700 }}>20% OFF</div>
//             </div>

//             {/* 7. 15% Off */}
//             <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '12px 6px', textAlign: 'center', border: '1px solid #e2e8f0' }}>
//               <div style={{ fontSize:'16px', fontWeight:800, color:'#8b5cf6' }}>{loading ? '...' : fmt(stats?.discount15Wins)}</div>
//               <div style={{ fontSize:'11px', color:'#64748b', marginTop:'4px', fontWeight:700 }}>15% OFF</div>
//             </div>

//             {/* 8. 5% Off */}
//             <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '12px 6px', textAlign: 'center', border: '1px solid #e2e8f0' }}>
//               <div style={{ fontSize:'16px', fontWeight:800, color:'#14b8a6' }}>{loading ? '...' : fmt(stats?.discount5Wins)}</div>
//               <div style={{ fontSize:'11px', color:'#64748b', marginTop:'4px', fontWeight:700 }}>5% OFF</div>
//             </div>

//             {/* 9. Bumper Offer */}
//             <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '12px 6px', textAlign: 'center', border: '1px solid #e2e8f0' }}>
//               <div style={{ fontSize:'16px', fontWeight:800, color:'#f59e0b' }}>{loading ? '...' : fmt(stats?.bumperWins)}</div>
//               <div style={{ fontSize:'11px', color:'#64748b', marginTop:'4px', fontWeight:700 }}>Bumper Offer</div>
//             </div>

//           </div>
//         </div>

//         {/* Social Follow Section */}
//         <p style={{
//           textAlign    : 'center',
//           fontWeight   : 800,
//           fontSize     : '14px',
//           color        : '#1e293b',
//           marginBottom : '12px',
//         }}>
//           Follow us for the next campaign
//         </p>

//         <div style={{ display:'flex', gap:'10px', justifyContent:'center' }}>
//           {/* Facebook */}
//           <a
//             href="https://www.facebook.com/LogoPakistan/?_rdc=1&_rdr#"
//             target="_blank"
//             rel="noreferrer"
//             style={{
//               flex          : 1,
//               maxWidth      : '130px',
//               height        : '64px',
//               borderRadius  : '14px',
//               background    : '#1877F2',
//               display       : 'flex',
//               flexDirection : 'column',
//               alignItems    : 'center',
//               justifyContent: 'center',
//               gap           : '4px',
//               textDecoration: 'none',
//               boxShadow     : '0 4px 12px rgba(24,119,242,0.3)',
//               transition    : 'transform 0.15s ease',
//             }}
//             onMouseEnter={e => e.currentTarget.style.transform='translateY(-2px)'}
//             onMouseLeave={e => e.currentTarget.style.transform='translateY(0)'}
//           >
//             <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
//               <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
//             </svg>
//             <span style={{ color:'#fff', fontSize:'11px', fontWeight:700 }}>Facebook</span>
//           </a>

//           {/* TikTok */}
//           <a
//             href="https://www.tiktok.com/@logopakistan?lang=en"
//             target="_blank"
//             rel="noreferrer"
//             style={{
//               flex          : 1,
//               maxWidth      : '130px',
//               height        : '64px',
//               borderRadius  : '14px',
//               background    : '#000',
//               display       : 'flex',
//               flexDirection : 'column',
//               alignItems    : 'center',
//               justifyContent: 'center',
//               gap           : '4px',
//               textDecoration: 'none',
//               boxShadow     : '0 4px 12px rgba(0,0,0,0.3)',
//               transition    : 'transform 0.15s ease',
//             }}
//             onMouseEnter={e => e.currentTarget.style.transform='translateY(-2px)'}
//             onMouseLeave={e => e.currentTarget.style.transform='translateY(0)'}
//           >
//             <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
//               <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.34 6.34 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z"/>
//             </svg>
//             <span style={{ color:'#fff', fontSize:'11px', fontWeight:700 }}>TikTok</span>
//           </a>

//           {/* Instagram */}
//           <a
//             href="https://www.instagram.com/logopakistan/reels/"
//             target="_blank"
//             rel="noreferrer"
//             style={{
//               flex          : 1,
//               maxWidth      : '130px',
//               height        : '64px',
//               borderRadius  : '14px',
//               background    : 'linear-gradient(135deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)',
//               display       : 'flex',
//               flexDirection : 'column',
//               alignItems    : 'center',
//               justifyContent: 'center',
//               gap           : '4px',
//               textDecoration: 'none',
//               boxShadow     : '0 4px 12px rgba(188,24,136,0.3)',
//               transition    : 'transform 0.15s ease',
//             }}
//             onMouseEnter={e => e.currentTarget.style.transform='translateY(-2px)'}
//             onMouseLeave={e => e.currentTarget.style.transform='translateY(0)'}
//           >
//             <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
//               <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="white" strokeWidth="2"/>
//               <circle cx="12" cy="12" r="5" stroke="white" strokeWidth="2"/>
//               <circle cx="17.5" cy="6.5" r="1.3" fill="white"/>
//             </svg>
//             <span style={{ color:'#fff', fontSize:'11px', fontWeight:700 }}>Instagram</span>
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// }








import React, { useEffect, useState } from 'react';
import api from '../api/api';

const EMPTY_STATS = {
  winners: 0,
  ladiesFootwearWins: 0,
  mensFootwearWins: 0,
  accessoriesWins: 0,
  startDate: null,
  endDate: null,
};

const SUBCATEGORIES = [
    ['accessoriesWins', 'Accessories', '👜', 'Finishing touches won', 'lilac'],
  ['mensFootwearWins', "Men's Footwear", '👞', 'Styles won in Men Collection', 'blue'],
  ['ladiesFootwearWins', "Ladies' Footwear", '👠', 'Styles won in Ladies Collection', 'rose'],
];

const fmt = (value) => {
  const n = Number(value ?? 0);
  return Number.isFinite(n) ? n.toLocaleString() : '0';
};

const dateRange = (stats) => {
  if (!stats?.startDate || !stats?.endDate) return '';
  const parse = (value) => {
    const text = String(value);
    const d = new Date(/^\d{4}-\d{2}-\d{2}$/.test(text) ? `${text}T00:00:00` : text);
    return Number.isNaN(d.getTime()) ? null : d;
  };
  const start = parse(stats.startDate);
  const end = parse(stats.endDate);
  if (!start || !end) return '';
  const format = (d) => new Intl.DateTimeFormat('en', { day: 'numeric', month: 'short', year: 'numeric' }).format(d);
  return `${format(start)} - ${format(end)}`;
};

const styles = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  
  .cs-page {
    --ink: #172554;
    min-height: 100vh;
    min-height: 100dvh;
    padding: 16px 20px 20px;
    color: var(--ink);
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, sans-serif;
    background: radial-gradient(ellipse at 12% 3%, #6366f11a, transparent 32%),
                radial-gradient(ellipse at 92% 15%, #fbbf2420, transparent 28%), #f5f7fc;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .cs-nav {
    max-width: 1000px;
    width: 100%;
    height: 52px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #94a3b826;
  }
  .cs-brand { display: flex; align-items: center; gap: 10px; font-size: 16px; font-weight: 900; letter-spacing: 1px; }
  .cs-logo { width: 34px; height: 34px; display: grid; place-items: center; border-radius: 10px; color: white; font-size: 16px; background: linear-gradient(145deg, #202b75, #5366e8); box-shadow: 0 6px 14px #3b4fc733; }
  .cs-nav-label { color: #64748b; font-size: 11px; font-weight: 800; letter-spacing: .08em; text-transform: uppercase; }
  
  .cs-shell {
    max-width: 1000px;
    width: 100%;
    margin: 12px auto 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 16px;
  }
  
  /* HERO SECTION */
  .cs-hero {
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    padding: 24px 28px;
    border-radius: 24px;
    color: white;
    background: linear-gradient(118deg, #111b50, #26398d 54%, #4d5de0);
    box-shadow: 0 18px 45px #1e296330;
  }
  .cs-hero:after { content: ""; position: absolute; width: 220px; height: 220px; right: -50px; bottom: -130px; border-radius: 50%; background: #ffffff12; pointer-events: none; }
  .cs-copy, .cs-winner { position: relative; z-index: 1; }
  .cs-eyebrow { display: inline-flex; gap: 6px; padding: 5px 10px; border: 1px solid #ffffff30; border-radius: 99px; background: #ffffff17; color: #e0e7ff; font-size: 10px; font-weight: 900; letter-spacing: .12em; text-transform: uppercase; }
  .cs-title { margin: 10px 0 6px; font-size: clamp(22px, 4.5vw, 36px); line-height: 1.15; letter-spacing: -.03em; font-weight: 900; }
  .cs-description { max-width: 520px; margin: 0; color: #dbe4ff; font-size: 13px; line-height: 1.5; }
  .cs-dates { display: inline-flex; gap: 6px; margin-top: 12px; padding: 5px 10px; border-radius: 8px; background: #0f172a38; font-size: 11px; font-weight: 700; }
  
  .cs-winner { padding: 18px 22px; border: 1px solid #ffffff38; border-radius: 18px; background: linear-gradient(145deg, #ffffff30, #ffffff12); box-shadow: inset 0 1px #ffffff2b, 0 12px 26px #0910362e; text-align: center; backdrop-filter: blur(8px); flex-shrink: 0; min-width: 110px; }
  .cs-trophy { margin-bottom: 4px; font-size: 22px; }
  .cs-winner-number { font-size: clamp(28px, 4vw, 42px); line-height: 1; font-weight: 950; letter-spacing: -.04em; }
  .cs-winner-label { margin-top: 4px; color: #e0e7ff; font-size: 10px; font-weight: 900; letter-spacing: .1em; text-transform: uppercase; }
  
  /* CATEGORIES SECTION */
  .cs-section { display: flex; flex-direction: column; gap: 12px; flex: 1; justify-content: center; }
  .cs-heading { display: flex; justify-content: space-between; align-items: flex-end; gap: 12px; margin: 0 2px; }
  .cs-kicker { margin: 0 0 2px; color: #6366f1; font-size: 10px; font-weight: 900; letter-spacing: .14em; text-transform: uppercase; }
  .cs-h2 { margin: 0; color: #172554; font-size: 18px; font-weight: 900; letter-spacing: -.02em; }
  .cs-sub { margin: 2px 0 0; color: #64748b; font-size: 12px; }
  .cs-badge { padding: 5px 10px; border: 1px solid #e2e8f0; border-radius: 99px; background: white; color: #64748b; font-size: 10px; font-weight: 800; white-space: nowrap; }
  
  .cs-categories { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 14px; flex: 1; }
  .cs-category { position: relative; overflow: hidden; padding: 18px; border: 1px solid transparent; border-radius: 20px; box-shadow: 0 6px 18px #1e293b0a; transition: transform .18s, box-shadow .18s; display: flex; flex-direction: column; justify-content: space-between; }
  .cs-category:hover { transform: translateY(-2px); box-shadow: 0 12px 24px #1e293b12; }
  .cat-rose { background: linear-gradient(135deg, #fff1f5, #ffe3eb); border-color: #ffe0ea; }
  .cat-blue { background: linear-gradient(135deg, #eff7ff, #e0efff); border-color: #dcecff; }
  .cat-lilac { background: linear-gradient(135deg, #f3f0ff, #e9e5ff); border-color: #e6e0ff; }
  .cs-cat-info { display: flex; flex-direction: column; }
  .cs-cat-icon { display: grid; place-items: center; width: 40px; height: 40px; border-radius: 12px; background: #ffffffd9; font-size: 20px; box-shadow: 0 4px 10px #1e293b0d; }
  .cs-cat-name { margin: 12px 0 4px; color: #1e293b; font-size: 15px; font-weight: 900; line-height: 1.2; }
  .cs-cat-detail { margin: 0; color: #64748b; font-size: 11px; line-height: 1.35; }
  .cs-cat-count { margin-top: 10px; font-size: 26px; font-weight: 950; color: #172554; letter-spacing: -.03em; }
  
  /* REAL SOCIAL ICONS & SECTION */
  .cs-social { display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 16px 20px; border: 1px solid #e7ebf2; border-radius: 20px; background: white; box-shadow: 0 6px 20px #1e293b08; }
  .cs-social h2 { margin: 0; color: #172554; font-size: 14px; font-weight: 900; }
  .cs-social p { margin: 3px 0 0; color: #64748b; font-size: 11px; }
  .cs-links { display: flex; gap: 10px; flex-shrink: 0; }
  .cs-link { display: grid; place-items: center; width: 38px; height: 38px; border-radius: 12px; color: white; text-decoration: none; transition: transform .18s, box-shadow .18s; box-shadow: 0 4px 10px rgba(0,0,0,0.1); }
  .cs-link:hover { transform: translateY(-2px); box-shadow: 0 6px 14px rgba(0,0,0,0.18); }
  .cs-link svg { width: 18px; height: 18px; fill: currentColor; }
  
  .cs-facebook { background: #1877f2; }
  .cs-tiktok { background: #000000; }
  .cs-instagram { background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%); }
  
  .cs-error { margin-top: 8px; padding: 10px 12px; border: 1px solid #fed7aa; border-radius: 12px; background: #fff7ed; color: #9a3412; font-size: 11px; }
  .cs-footer { text-align: center; color: #94a3b8; font-size: 10px; padding-top: 4px; }

  /* 📱 MOBILE VIEW */
  @media (max-width: 680px) {
    .cs-page { padding: 12px 14px 16px; }
    .cs-nav { height: 44px; border-bottom: 1px solid #94a3b81a; }
    .cs-logo { width: 30px; height: 30px; border-radius: 9px; font-size: 14px; }
    .cs-brand { font-size: 14px; gap: 8px; }
    .cs-nav-label { font-size: 9px; }

    .cs-shell { margin-top: 10px; gap: 14px; }
    
    .cs-hero { flex-direction: row; align-items: center; padding: 16px 18px; border-radius: 20px; gap: 12px; }
    .cs-title { font-size: 18px; margin: 4px 0 2px; }
    .cs-description { font-size: 11px; line-height: 1.35; }
    .cs-dates { font-size: 9px; padding: 4px 8px; margin-top: 6px; }

    .cs-winner { padding: 10px; border-radius: 14px; min-width: 78px; width: 78px; display: flex; flex-direction: column; align-items: center; justify-content: center; }
    .cs-trophy { font-size: 16px; margin-bottom: 2px; }
    .cs-winner-number { font-size: 22px; }
    .cs-winner-label { font-size: 8px; margin-top: 2px; }

    .cs-heading { margin-bottom: 4px; }
    .cs-h2 { font-size: 15px; }
    .cs-sub { font-size: 10px; }

    .cs-categories { grid-template-columns: 1fr; gap: 10px; }
    .cs-category { flex-direction: row; align-items: center; justify-content: space-between; padding: 14px 16px; border-radius: 16px; }
    .cs-cat-info { display: flex; flex-direction: row; align-items: center; gap: 12px; }
    .cs-cat-icon { width: 38px; height: 38px; border-radius: 10px; font-size: 18px; flex-shrink: 0; }
    .cs-cat-name { font-size: 14px; margin: 0; line-height: 1.2; white-space: nowrap; }
    .cs-cat-detail { font-size: 10px; margin-top: 2px; line-height: 1.2; display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden; }
    .cs-cat-count { font-size: 22px; margin-top: 0; flex-shrink: 0; }

    .cs-social { padding: 14px 16px; border-radius: 16px; }
    .cs-social h2 { font-size: 12px; }
    .cs-social p { font-size: 9.5px; }
    .cs-link { width: 34px; height: 34px; border-radius: 10px; }
    .cs-link svg { width: 16px; height: 16px; }
  }

  @media (prefers-reduced-motion: reduce) {
    .cs-category, .cs-link { transition: none; }
    .cs-category:hover, .cs-link:hover { transform: none; }
  }
`;

export default function CampaignStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    api.get('/campaign/stats')
      .then((response) => {
        if (!active) return;
        const payload = response.data?.data ?? response.data;
        setStats(payload && typeof payload === 'object' ? payload : EMPTY_STATS);
      })
      .catch((err) => {
        console.error('Failed to fetch campaign stats:', err);
        if (!active) return;
        setError('Campaign results are temporarily unavailable. Please try again later.');
        setStats(EMPTY_STATS);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, []);

  const dates = dateRange(stats);

  return (
    <main className="cs-page">
      <style>{styles}</style>
      
      <header className="cs-nav">
        <div className="cs-brand">
          <div className="cs-logo" aria-hidden="true">L</div>
          <span>LOGO</span>
        </div>
        <span className="cs-nav-label">Spin &amp; Win Campaign</span>
      </header>

      <div className="cs-shell">
        <section className="cs-hero" aria-labelledby="cs-title">
          <div className="cs-copy">
            <div className="cs-eyebrow"><span aria-hidden="true">✦</span> Campaign recap</div>
            <h1 className="cs-title" id="cs-title">The campaign has ended.</h1>
            <p className="cs-description">Thank you for being part of LOGO Spin &amp; Win. Here is a look at the subcategory rewards won by our community.</p>
            {dates && <div className="cs-dates"><span aria-hidden="true">◷</span>{dates}</div>}
          </div>
          <div className="cs-winner" aria-live="polite">
            <div className="cs-trophy" aria-hidden="true">🏆</div>
            <div>
              <div className="cs-winner-number">{loading ? '...' : fmt(stats?.winners)}</div>
              <div className="cs-winner-label">Total winners</div>
            </div>
          </div>
        </section>

        {error && <div className="cs-error" role="status">{error}</div>}

        <section className="cs-section" aria-labelledby="cs-categories">
          <div className="cs-heading">
            <div>
              <p className="cs-kicker">Subcategory Winners</p>
              <h2 className="cs-h2" id="cs-categories">Winning Subcategories</h2>
              <p className="cs-sub">Breakdown of rewards claimed across subcategories.</p>
            </div>
          </div>

          <div className="cs-categories">
            {SUBCATEGORIES.map(([key, name, emoji, detail, color]) => (
              <article className={`cs-category cat-${color}`} key={key}>
                <div className="cs-cat-info">
                  <div className="cs-cat-icon" aria-hidden="true">{emoji}</div>
                  <div>
                    <h3 className="cs-cat-name">{name}</h3>
                    <p className="cs-cat-detail">{detail}</p>
                  </div>
                </div>
                <div className="cs-cat-count" aria-live="polite">
                  {loading ? '...' : fmt(stats?.[key] ?? stats?.[name] ?? 0)}
                </div>
              </article>
            ))}
          </div>
        </section>

        {/* 🚀 UPGRADED SOCIAL BAR WITH REAL SVG LOGOS & NEW CATCHY CALL-TO-ACTION */}
        <section className="cs-social" aria-label="Follow LOGO">
          <div>
            <h2>Don't miss out on the next big win! 🎉</h2>
            <p>Follow LOGO to stay updated for our upcoming campaigns, exclusive rewards &amp; new collections.</p>
          </div>
          <div className="cs-links">
            {/* Facebook Real Vector Icon */}
            <a className="cs-link cs-facebook" href="https://www.facebook.com/LogoPakistan/?_rdc=1&_rdr#" target="_blank" rel="noreferrer" aria-label="LOGO on Facebook">
              <svg viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            </a>
            {/* TikTok Real Vector Icon */}
            <a className="cs-link cs-tiktok" href="https://www.tiktok.com/@logopakistan?lang=en" target="_blank" rel="noreferrer" aria-label="LOGO on TikTok">
              <svg viewBox="0 0 24 24"><path d="M12.525.001h3.01c.002 1.109.424 2.13 1.187 2.893a4.26 4.26 0 002.893 1.187v3.01a7.27 7.27 0 01-4.08-1.252v8.283c0 3.861-3.13 6.99-6.99 6.99-3.861 0-6.99-3.129-6.99-6.99 0-3.86 3.129-6.99 6.99-6.99.378 0 .748.031 1.109.091v3.091a3.91 3.91 0 00-1.109-.158c-2.15 0-3.9 1.75-3.9 3.9 0 2.15 1.75 3.9 3.9 3.9 2.15 0 3.9-1.75 3.9-3.9V0z"/></svg>
            </a>
            {/* Instagram Real Vector Icon */}
            <a className="cs-link cs-instagram" href="https://www.instagram.com/logopakistan/reels/" target="_blank" rel="noreferrer" aria-label="LOGO on Instagram">
              <svg viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
            </a>
          </div>
        </section>

        <footer className="cs-footer">LOGO · Spin &amp; Win campaign recap</footer>
      </div>
    </main>
  );
}